import { useState, type FormEvent } from "react";
import { Link, useNavigate } from "react-router-dom";
import { creators } from "@/mocks/creators";
import CompareSlider from "@/components/feature/CompareSlider";

const heroTags = ["美妆护肤", "穿搭时尚", "剧情搞笑", "健身运动", "旅行户外"];

export default function Hero() {
  const navigate = useNavigate();
  const [keyword, setKeyword] = useState("");
  const spotlight = creators[0];

  const submit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const value = keyword.trim();
    navigate(value ? `/bang?q=${encodeURIComponent(value)}` : "/bang");
  };

  return (
    <section className="relative w-full overflow-hidden border-b border-background-200 bg-background-50">
      <div
        aria-hidden="true"
        className="pointer-events-none absolute -right-24 -top-24 h-72 w-72 rounded-full bg-accent-100/70"
      ></div>
      <div
        aria-hidden="true"
        className="pointer-events-none absolute -bottom-28 left-1/3 h-64 w-64 rounded-full bg-primary-100/60"
      ></div>

      <div className="relative mx-auto grid w-full max-w-[1280px] grid-cols-1 items-center gap-10 px-4 py-12 md:px-8 md:py-16 lg:grid-cols-[1.05fr_0.95fr] lg:gap-14 lg:py-20">
        <div className="fc-rise">
          <p className="inline-flex items-center gap-2 rounded-full border border-accent-300 bg-accent-50 px-3.5 py-1.5 text-xs font-medium text-accent-900">
            <i className="ri-sparkling-2-line text-sm"></i>
            网红形象变化观察站
          </p>

          <h1 className="mt-5 font-heading text-3xl font-black leading-tight text-foreground-950 md:text-[44px] md:leading-[1.18]">
            网红反差，
            <br className="hidden sm:block" />
            一眼看清
            <span className="relative mx-1 inline-block">
              <span className="relative z-10 text-primary-600">变化有多大</span>
              <span
                aria-hidden="true"
                className="absolute inset-x-0 bottom-1 z-0 h-3 rounded-sm bg-accent-200/80"
              ></span>
            </span>
          </h1>

          <p className="mt-5 max-w-xl text-sm leading-relaxed text-foreground-600 md:text-base">
            把同一位博主的早期素人照、公开露面照与近期精修图放在一起，按人成组整理。
            不用再一条条翻主页考古，打开就能直接对照画面与状态。
          </p>

          <form
            onSubmit={submit}
            role="search"
            className="mt-7 flex w-full max-w-xl flex-col gap-2 sm:flex-row"
          >
            <label className="flex flex-1 items-center gap-2 rounded-md border border-background-300 bg-background-100 px-4 py-3">
              <i className="ri-search-eye-line text-lg text-foreground-500"></i>
              <span className="sr-only">搜索博主</span>
              <input
                type="search"
                value={keyword}
                onChange={(event) => setKeyword(event.target.value)}
                placeholder="输入博主名或领域，例如：美妆、穿搭"
                aria-label="搜索对比对象"
                className="w-full bg-transparent text-sm text-foreground-900 outline-none placeholder:text-foreground-500"
              />
            </label>
            <button
              type="submit"
              className="cursor-pointer whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              搜索对比
            </button>
          </form>

          <div className="mt-5 flex flex-wrap items-center gap-2">
            <span className="text-xs text-foreground-500">热门领域</span>
            {heroTags.map((tag) => (
              <Link
                key={tag}
                to={`/bang?q=${encodeURIComponent(tag)}`}
                className="cursor-pointer rounded-full border border-background-300 bg-background-100 px-3 py-1 text-xs text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700"
              >
                {tag}
              </Link>
            ))}
          </div>

          <dl className="mt-8 grid grid-cols-2 gap-4 border-t border-background-200 pt-6 sm:grid-cols-4">
            <div>
              <dt className="text-xs text-foreground-500">已收录对象</dt>
              <dd className="mt-1 font-heading text-xl font-bold text-foreground-950">312 位</dd>
            </div>
            <div>
              <dt className="text-xs text-foreground-500">对比组图</dt>
              <dd className="mt-1 font-heading text-xl font-bold text-foreground-950">1874 组</dd>
            </div>
            <div>
              <dt className="text-xs text-foreground-500">覆盖平台</dt>
              <dd className="mt-1 font-heading text-xl font-bold text-foreground-950">4 个</dd>
            </div>
            <div>
              <dt className="text-xs text-foreground-500">内容更新</dt>
              <dd className="mt-1 font-heading text-xl font-bold text-primary-600">每日</dd>
            </div>
          </dl>
        </div>

        <div className="fc-rise">
          <div className="mb-3 flex flex-wrap items-center justify-between gap-2">
            <p className="flex items-center gap-2 text-sm font-medium text-foreground-800">
              <i className="ri-fire-line text-primary-500"></i>
              今日对比焦点：{spotlight.name}
            </p>
            <Link
              to={`/detail/${spotlight.slug}`}
              className="cursor-pointer whitespace-nowrap text-xs text-primary-600 hover:text-primary-700"
            >
              查看完整档案
            </Link>
          </div>
          <CompareSlider
            beforeImage={spotlight.beforeImage}
            afterImage={spotlight.afterImage}
            beforeLabel={`${spotlight.beforeYear} 早期`}
            afterLabel={`${spotlight.afterYear} 现在`}
            name={spotlight.name}
          />
        </div>
      </div>
    </section>
  );
}